import React from "react";
import { Box } from "@mui/material";
import FormField from "../../../../../components/FormField";
import OccupantFilter from "../../../../../components/filters/OccupantFilter";
import "../index.css";
import { useNitroCAStore } from "../../../../../store/CompetitiveAnalysisStore";

interface Location {
  id: string;
  name: string;
}

interface FindMissingOriginProps {
  setOccupant: (value: Location) => void;
}

const FindOccupant: React.FC<FindMissingOriginProps> = ({ setOccupant }) => {
  const [{origin}] = useNitroCAStore((state) => [state.originToTroubleshoot]);

  return (
    <div className="find-missing-origin-container">
      <div className="find-missing-origin-header">Select Occupant</div>
      <div className="find-missing-origin-header-content">
        Select an occupant to explore why this origin is missing.
      </div>

      {/* --- Existing Form Fields --- */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {/* Origin Field */}
        <span className="find-missing-origin-title">Facility Name</span>
        <div className="find-missing-origin-name">
          <span style={{ paddingLeft: "5px" }}>{origin.name}</span>
        </div>
        {/* Occupant Field */}
        <FormField label="Occupant Name">
          <OccupantFilter
            locationId={origin.id}
            disabled={!origin.id}
            setValue={setOccupant}
            config={{ valueRequired: true }}
          />
        </FormField>
      </Box>
    </div>
  );
};

export default FindOccupant;
